import { render, staticRenderFns } from "./VisitPhotosGallery.vue?vue&type=template&id=70ae189a&scoped=true&"
import script from "./VisitPhotosGallery.vue?vue&type=script&lang=js&"
export * from "./VisitPhotosGallery.vue?vue&type=script&lang=js&"
import style0 from "./VisitPhotosGallery.vue?vue&type=style&index=0&id=70ae189a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae189a",
  null
  
)

export default component.exports